import React, { useContext } from 'react';
import './NavTeams.css';
import CurrentUserContext from '../../Contexts/userContexts';
import { Link } from 'react-router-dom';
import './NavTeams.css';
import NavTeamsSwipe from './NavTeamsSwipe';

const NavTeams = () => {


    const { singlePlayer, setTeamSearchValue } = useContext(CurrentUserContext)

    const arrBadge = []

    singlePlayer.map(resultBadge => arrBadge.push(resultBadge.player[0].strTeamBadge))


    let newBadge = [...new Set(arrBadge)]

    const leagueTarget = (badge) => {

        setTeamSearchValue(badge);

    }


    return (
        <>
            <div className='badge-container'>

                {
                    newBadge.map(badge => (
                        <Link to='/players'>
                            <div className='badges' key={badge} onClick={() => leagueTarget(badge)}>
                                <div className="container-badge"></div>
                                <img src={badge} alt="" />
                            </div>
                        </Link>
                    ))
                }

            </div>
            <NavTeamsSwipe />
        </>
    );

}

export default NavTeams;


